module.exports = __webpack_public_path__ + "img/banner-new.8559240.png";